import React from 'react';
import DivergentArrowsIcon from '@components/cart/icons/DivergentArrowsIcon';
import { toggleIsVisible } from '@utils/ui-utils';

const LightBoxButton = ({
	imageSrc,
	imageAlt,
	width,
	height,
	className,
	color,
	imageSubtitle,
	useActions,
	price,
	onLightBoxActionClick,
}) => {
	return (
		<DivergentArrowsIcon
			width={width}
			height={height}
			onClick={e => {
				e.stopPropagation();
				toggleIsVisible(imageSrc, imageAlt, useActions, price, imageSubtitle, onLightBoxActionClick);
			}}
			className={className}
			color={color}
		/>
	);
};

LightBoxButton.defaultProps = {
	imageSrc: '',
	imageAlt: '',
	className: '',
	imageSubtitle: '',
	price: '',
	useActions: false,
	onLightBoxActionClick: () => {},
};

export default LightBoxButton;
